import { c as _c } from "react/compiler-runtime";
import { FlexCenter, FlexColumn, Separator, SkeletonBlock, TextHeadingSkeleton } from "@opensea/ui-kit";
import { PreviewTooltipContent } from "@/components/tooltip/PreviewTooltip";
import { ItemMetadataChipsSkeleton } from "../item-page/ItemMetadataChips/ItemMetadataChipsSkeleton";
import { ItemPreviewTooltipTraitTableSkeleton } from "./TraitTable/ItemPreviewTooltipTraitTableSkeleton";
export function ItemPreviewTooltipContentSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FlexCenter><SkeletonBlock className="size-[200px] rounded" /></FlexCenter>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PreviewTooltipContent className="gap-3">{t0}<FlexColumn><FlexColumn className="gap-1"><TextHeadingSkeleton className="w-1/3" size="xs" /><ItemMetadataChipsSkeleton count={2} variant="default" /></FlexColumn><Separator className="my-2" /><ItemPreviewTooltipTraitTableSkeleton /></FlexColumn></PreviewTooltipContent>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}